// https://github.com/Genymobile/scrcpy/blob/41abe021e2a73efd4899b0efcd0b9eef9ec68c9b/server/src/main/java/com/genymobile/scrcpy/DeviceMessage.java#L5
export enum ScrcpyDeviceMessageType {
    Clipboard,
    AckClipboard,
}
